/// <reference path="../../../../../typings/index.d.ts" />
/// <reference path="../app.common.directives.module.ts" />
/// <reference path="validatorbase.ts" />
/// <reference path="validateargs.ts" />
/// <reference path="../../services/globalsettingsservice.ts" />

module App.Common.Directives {
	'use strict';

	export class MustBeSameAs extends Directives.ValidatorBase {

		public comparisonDescription: string;

		public name = 'must-be-same-as';

		constructor() {
			super();
			this.comparisonDescription = 'same as';
		}

		public isValid = (args: Directives.ValidateArgs) => {
			return args.modelValue() === args.parameterValue();
		};

		public getWatchExpressions = (args: Directives.ValidateArgs) => {
			return [args.parameter, args.attributes.ngModel];
		};
		public resolveMessage = (args: ValidateArgs): string => {
			var label = args.attributes[`${this.nameCamelCase()}Label`];
			return `This field must be ${this.comparisonDescription} ${label}`;
		};
	}

	function factory() {
		return new MustBeSameAs();
	}

	angular
		.module('app.common.directives')
		.directive('mustBeSameAs', factory);
}